export const TaskStatus = Object.freeze({
	Pending: 'pending',
	InProgress: 'in_progress',
	Completed: 'completed',
	SupposedlyCompleted: 'supposedly_completed',
	Deferred: 'deferred',
});
